import gql from "graphql-tag";

export const SPLIT_DOCUMENT = gql`
	mutation SplitDocument(
		$input: SplitDocumentInput!
	) {
		splitDocument(input: $input) {
			int
		}
	}
`;
